import React from "react"
import PropTypes from "prop-types"
import { DEFAULTS } from "@constants"
import { Status, Table } from "@bitcine/cs-theme"
import Poster from "./components/poster"
import { GLOBALS } from "@src/config"

class SelectProject extends React.Component {
  constructor(props) {
    super(props)
    this.get = `${GLOBALS.API_URL}/delivery/projects`
    this.state = {
      status: "PENDING",
      projects: []
    }
  }
  componentDidMount() {
    fetch(this.get, DEFAULTS)
      .then(res => res.json())
      .then(projects => this.setState({ status: "READY", projects }))
      .catch(error => this.setState({ status: "ERROR", error }))
  }
  setProject(_id) {
    this.props.setProject(_id)
  }
  render() {
    const { status, projects } = this.state
    return (
      <Status pending={status === "PENDING"} error={status === "ERROR"}>
        <div>
          <Table
            widths={["65", "auto", "65"]}
            header={{
              columns: [{ text: "Project" }]
            }}
            body={{
              data: projects,
              row: {
                onClick: (event, project) => this.setProject(project._id),
                render: [
                  data => <Poster poster={data.poster}/>,
                  data => (
                    <div className='truncate'>
                      <small className='block muted'>Project Title</small>
                      <h4>{data.title}</h4>
                    </div>
                  ),
                  data => <span className='material-icons'>keyboard_arrow_right</span>
                ]
              }
            }}/>
        </div>
      </Status>
    )
  }
}

SelectProject.propTypes = {
  setProject: PropTypes.func.isRequired
}

export default SelectProject
